export default __webpack_public_path__ + "static/media/GEN_Crisis_01.2b2b6c26.jpg";